<app-ui-menu-wrapper>
  <!-- Event selector -->
  <app-event-selector></app-event-selector>

  <!-- Zoom in and zoom out controls -->
  <app-zoom-controls></app-zoom-controls>

  <app-view-options></app-view-options>

  <app-auto-rotate></app-auto-rotate>

  <!-- Dark theme toggle -->
  <app-dark-theme></app-dark-theme>

  <!-- Toggle for clipping geometries -->
  <app-object-clipping
    *ngIf="uiConfig.showObjectClipping"
  ></app-object-clipping>

  <!-- Main view toggle -->
  <app-main-view-toggle></app-main-view-toggle>

  <!-- Toggle for overlay panel -->
  <app-overlay-view *ngIf="uiConfig.showOverlayView"></app-overlay-view>

  <!-- Toggle for selected object panel -->
  <app-object-selection
    *ngIf="uiConfig.showObjectSelection"
  ></app-object-selection>

  <!-- Toggle for animating the event data -->
  <app-animate-event *ngIf="uiConfig.showAnimateEvent"></app-animate-event>

  <!-- Toggle for animating camera through event -->
  <app-animate-camera
    *ngIf="uiConfig.showAnimateCamera"
    [animationPresets]="animationPresets"
  ></app-animate-camera>

  <!-- More information panels -->
  <app-more-info
    [uiConfig]="uiConfig"
    [kinematicsConfig]="kinematicsConfig"
  ></app-more-info>

  <!-- Masterclass: tag particles and calculate invariant mass -->
  <app-masterclass-panel
    *ngIf="uiConfig?.showMasterclassPanel"
    [config]="masterclassConfig"
  ></app-masterclass-panel>

  <!-- Toggle for performance -->
  <app-performance-toggle
    *ngIf="uiConfig.showPerformanceToggle"
  ></app-performance-toggle>

  <!-- Toggle for VR -->
  <app-vr-toggle *ngIf="uiConfig.showVRToggle"></app-vr-toggle>

  <!-- Toggle for AR -->
  <app-ar-toggle *ngIf="uiConfig.showARToggle"></app-ar-toggle>

  <!-- Make pictures from scene -->
  <app-make-picture *ngIf="uiConfig.showMakePicture"></app-make-picture>

  <!-- Toggle for loading geometries modal-->
  <app-io-options
    [eventDataImportOptions]="eventDataImportOptions"
  ></app-io-options>

  <!-- Toggle for shareable link constructor modal-->
  <app-share-link *ngIf="uiConfig.showShareLink"></app-share-link>

  <!-- Histogram panel -->
  <app-histogram-panel
    *ngIf="uiConfig?.showHistogramPanel"
    [config]="histogramConfig"
  ></app-histogram-panel>

  <!-- Extra options -->
  <ng-content></ng-content>
</app-ui-menu-wrapper>
